import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import Button from '../button';
import Spacer from '../spacer';
import LabelDataPair from '../label-data-pair';
import Referral from './referral';
import Container from './container';
const TYPES = ['default', 'with-icon'];
const StyledText = styled.View`
  flex-direction: row;
  justify-content: flex-start;
`;
const styles = {
  container: {
    paddingVertical: 11
  },
  icon: {
    alignSelf: 'center'
  }
};

function HighlightedContent(props) {
  const type = TYPES.includes(props.type) ? props.type : HighlightedContent.defaultProps.type;
  const IconType = props.iconFamily;
  return /*#__PURE__*/React.createElement(Container, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(StyledText, null, type === 'with-icon' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: styles.icon
  }, /*#__PURE__*/React.createElement(IconType, {
    name: props.iconName,
    color: props.iconColor,
    size: 20
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  })), /*#__PURE__*/React.createElement(LabelDataPair, {
    type: "top-left",
    weight: "regular",
    label: props.label
  }, props.children)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }), /*#__PURE__*/React.createElement(Button.Text, {
    size: "small",
    onPress: props.onPress
  }, props.buttonName));
}

HighlightedContent.defaultProps = {
  type: 'default',
  label: 'Label',
  buttonName: 'button',
  onPress: () => {},
  iconName: '',
  iconFamily: '',
  iconColor: '',
  children: ''
};
HighlightedContent.propTypes = {
  type: PropTypes.oneOf(TYPES),
  label: PropTypes.string,
  buttonName: PropTypes.string,
  onPress: PropTypes.func,
  iconName: PropTypes.string,
  iconFamily: PropTypes.elementType,
  iconColor: PropTypes.string,
  children: PropTypes.node
};
HighlightedContent.Referral = Referral;
export default HighlightedContent;
//# sourceMappingURL=index.js.map